module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1051-4f5ac55f1de311bdf59665dd1923d1ea.png";